module.exports = __webpack_public_path__ + "static/img/user-avatar.6f05e1a6.png";